function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search-outline_svg__cls-1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "search-outline_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "search-outline_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "search-outline_svg__cls-1",
  cx: 13.83,
  cy: 13.83,
  r: 12.83
}), /*#__PURE__*/React.createElement("path", {
  className: "search-outline_svg__cls-1",
  d: "M34 34L23 23"
})));

function SvgSearchOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35"
  }, props), _ref, _ref2);
}

export default SvgSearchOutline;